import { lazy, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import RoleProtectedRoute from './components/RoleProtectedRoute'
import { PageLoading } from './components/AsyncState'

const SignIn = lazy(() => import('./pages/SignIn'))
const SsoCheck = lazy(() => import('./pages/SsoCheck'))
const SsoCallback = lazy(() => import('./pages/SsoCallback'))
const Members = lazy(() => import('./pages/Members'))
const SignOut = lazy(() => import('./pages/SignOut'))
const AdminLayout = lazy(() => import('./components/AdminLayout'))
const AdminUsers = lazy(() => import('./pages/AdminUsers'))
const AdminFeatures = lazy(() => import('./pages/AdminFeatures'))
const AdminLocale = lazy(() => import('./pages/AdminLocale'))
const AdminRules = lazy(() => import('./pages/AdminRules'))
const AdminGovernance = lazy(() => import('./pages/AdminGovernance'))
const AdminInvites = lazy(() => import('./pages/AdminInvites'))
const AdminModels = lazy(() => import('./pages/AdminModels'))
const AdminSettings = lazy(() => import('./pages/AdminSettings'))
const NotFound = lazy(() => import('./pages/NotFound'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const ResetPassword = lazy(() => import('./pages/ResetPassword'))
const VerifyEmail = lazy(() => import('./pages/VerifyEmail'))
const ConfirmEmailChange = lazy(() => import('./pages/ConfirmEmailChange'))
const Settings = lazy(() => import('./pages/Settings'))

export default function RoutesConfig() {
  return (
    <Suspense fallback={<PageLoading label="Loading page..." />}>
      <Routes>
        <Route path="/" element={<ProtectedRoute><Members /></ProtectedRoute>} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/sso/check" element={<SsoCheck />} />
        <Route path="/sso/callback" element={<SsoCallback />} />
        <Route path="/signup" element={<Navigate to="/signin" replace />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/confirm-email-change" element={<ConfirmEmailChange />} />
        <Route path="/members" element={<Navigate to="/" replace />} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

        <Route
          path="/admin"
          element={
            <RoleProtectedRoute roles={['ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_MANAGER']}>
              <AdminLayout />
            </RoleProtectedRoute>
          }
        >
          <Route index element={<Navigate to="users" replace />} />
          <Route path="users" element={<RoleProtectedRoute roles={['ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_MANAGER']}><AdminUsers /></RoleProtectedRoute>} />
          <Route path="features" element={<RoleProtectedRoute roles={['ROLE_ADMIN', 'ROLE_MANAGER']}><AdminFeatures /></RoleProtectedRoute>} />
          <Route path="locale" element={<RoleProtectedRoute roles={['ROLE_ADMIN']}><AdminLocale /></RoleProtectedRoute>} />
          <Route path="rules" element={<RoleProtectedRoute roles={['ROLE_ADMIN']}><AdminRules /></RoleProtectedRoute>} />
          <Route path="governance" element={<RoleProtectedRoute roles={['ROLE_ADMIN', 'ROLE_MANAGER']}><AdminGovernance /></RoleProtectedRoute>} />
          <Route path="models" element={<RoleProtectedRoute roles={['ROLE_ADMIN', 'ROLE_MANAGER']}><AdminModels /></RoleProtectedRoute>} />
          <Route path="invites" element={<RoleProtectedRoute roles={['ROLE_ADMIN']}><AdminInvites /></RoleProtectedRoute>} />
          <Route path="settings" element={<RoleProtectedRoute roles={['ROLE_ADMIN']}><AdminSettings /></RoleProtectedRoute>} />
        </Route>

        <Route path="/signout" element={<SignOut />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  )
}
